import { combineReducers } from "redux";

//Auth
import Login from "./Auth/Login";
import Register from "./Auth/Register";
import ForgotPwd from "./Auth/ForgotPassword";
import resetPWD from "./Auth/ResetPassword";
import VerifyRegister from "./Auth/VerifyRegisterUser";

import Settings from "./Settings";

//User Management
import UserList from "./UserManagement/getUserList";
import GroupList from "./UserManagement/getGroupList";
import FranchiseList from "./UserManagement/getFranchiseList";

//User
import AddUser from "./UserManagement/AddUser";
import USerEditDetails from "./UserManagement/getUserDetails";
import DeleteUser from "./UserManagement/deleteUser";
import updateUser from "./UserManagement/UpdateUser";
import RoleList from "./UserManagement/getRoles";

//Residential Management
import CustomerList from "./ResidentialManagement/customerList";
import ServiceOrder from "./ResidentialManagement/serviceOrder";
import UpdateNotification from "./ResidentialManagement/updateNotification";
import UpdateCard from "./ResidentialManagement/updateCard";
import DeleteCard from "./ResidentialManagement/deleteCard";
import AddCard from "./ResidentialManagement/addNewCard";
import BlockList from "./ResidentialManagement/getBlockList";
import AccountNotes from "./ResidentialManagement/accountNotes";
import CardList from "./ResidentialManagement/getCardList";
import NotificationList from "./ResidentialManagement/getNotification";
import AuthorizedUser from "./ResidentialManagement/authorizedUser";
import CallLog from "./ResidentialManagement/callLog";
import PricingHistory from "./ResidentialManagement/pricingHistory";
import Service from "./ResidentialManagement/service";
import Pet from "./ResidentialManagement/pet";
import EmailReminder from "./ResidentialManagement/emailReminder";
import Lead from "./ResidentialManagement/lead";
import ServiceOrderEnquiry from "./ResidentialManagement/serviceOrderEnquiry";
import ZipcodeCheck from "./ResidentialManagement/zipcodeCheck";
import PricingCalc from "./ResidentialManagement/pricingCalculator";
import Invoice from "./ResidentialManagement/invoice";
import FieldTechnician from "./ResidentialManagement/fieldTechnician";
import DeletePhoneNumber from "./ResidentialManagement/deletePhoneNumber";
import RepresentativeList from "./ResidentialManagement/representativeList";
import ValidateCouponCode from "./ResidentialManagement/validateCoupon";
import ResVoidInvoice from "./ResidentialManagement/voidInvoice";
import CommVoidInvoice from "./CommercialManagement/voidInvoice";

//Group
import addGroup from "./UserManagement/addGroup";
import GroupEditDetails from "./UserManagement/getGroupDetails";
import DeleteGroup from "./UserManagement/deleteGroup";
import UpdateGroup from "./UserManagement/updateGroup";

//Case Management
import AllMessages from "./CaseManagement/getAllMessages";
import NewTicket from "./CaseManagement/createNewTickets";
import AllCustomer from "./CaseManagement/getAllCustomerList";
import RepliesonTicket from "./CaseManagement/repliesOnTicket";
import UpdateMesssage from "./CaseManagement/updateTicket";
import MessageCount from "./CaseManagement/getMessageCount";
import getReasons from "./CaseManagement/getReasons";

//Franchise Management
import FieldOffice from "./FranchiseManagement/getFieldOffice";
import FranchiseAdd from "./FranchiseManagement/addFranchise";
import CloseFranchise from "./FranchiseManagement/closeFranchise";
import EditFieldOffice from "./FranchiseManagement/editFranchiseDetails";
import UpdateFranchise from "./FranchiseManagement/updateFranchise";
import AddonUpdated from "./FranchiseManagement/addonUpdated";
import NewFieldAlert from "./FranchiseManagement/addNewAlert";
import FieldAlertsGet from "./FranchiseManagement/getFieldAlerts";
import UpdateAlert from "./FranchiseManagement/updateFieldAlert";
import StandardCleaning from "./FranchiseManagement/getStandardCleaning";
import UpdatePriceMatrix from "./FranchiseManagement/updatePriceMatrix";
import AddInitial from "./FranchiseManagement/addInitialCleaning";
import GetInitial from "./FranchiseManagement/getIntitalCleaning";
import DeleteInitial from "./FranchiseManagement/deleteIntialCleaning";
import StripeLogin from "./FranchiseManagement/stripeLogin";
import QuickbookLogin from "./FranchiseManagement/quickbookLogin";
import OptimorouteKey from './FranchiseManagement/optimorouteKey';
import FranchiseOverview from "./FranchiseManagement/franchiseOverview";
import InitialCleaning from "./FranchiseManagement/initialCleaning";
import StaxKeys from "./FranchiseManagement/getStaxKeys";
import UpdateStaxKeys from "./FranchiseManagement/updateStaxKeys";
import PulseMKeys from "./FranchiseManagement/getPulseMKeys";
import UpdatePulseMKeys from "./FranchiseManagement/updatePulseMKeys";
import ServiceNotificationKeys from "./FranchiseManagement/getServiceNotificationKeys";
import UpdateServiceNotificationKeys from "./FranchiseManagement/updateServiceNotificationKeys";

//Account Listing
import GetAccountList from "./Accounting/getAllAccountList";
import GetTabData from "./Accounting/getTabData";
import GetManualy from "./Accounting/addManualyPayment";
import DeleteInvoice from "./Accounting/deleteAcountInvoice";
import InvoiceProcess from "./Accounting/invoiceProcess";
import InvoiceEmailSend from "./Accounting/invoiceEmailSend";
import ExpiredCard from "./Accounting/getExpiredCard";
import ResendInvoice from "./Accounting/resendInvoice";
import VoidInvoice from "./Accounting/voidInvoice";
import SalesByItem from "./Accounting/salesByItem";
import InvoiceOverView from "./Accounting/invoiceOverView";
import AggingSummary from "./Accounting/getAggingSummary";
import GetSuspend from "./Accounting/getSuspendUnsuspend";
import MonthlyForecast from "./Accounting/geMonthlyForecast";
import SingleInvoice from "./Accounting/getSingleInvoice";
import UpdateSingleInvoice from "./Accounting/updateInvoice";
import DeleteLineItems from "./Accounting/deleteLineItems";
import FinalizeInvoice from "./Accounting/getFinalizeInvoice";
import PrintedInvoice from "./Accounting/printInvoice";
import SendInvoiceReminder from "./Accounting/sendReminder";
import PaymentHistory from "./Accounting/getPaymentHistory";
import PaymentHistoryNew from "./Accounting/getPaymentHistoryNew";
import InvoiceDescription from "./Accounting/getInvoiceDescription";
import WorkOrderTypeDescription from "./Accounting/getWorkOrderTypeDescription";
import GetQuickbooksSync from './Accounting/quickbooksSync';
import RefundPayment from "./Accounting/refundPayment";
import RemainingCreditBalance from "./ResidentialManagement/remainingCreditBalance";
import BatchInvoice from "./Accounting/batchInvoice";
import StaxCustomer from "./Accounting/getStaxCustomer";
import LastThreePayment from "./Accounting/lastThreePayment";
import WorkOrders from "./Accounting/getWorkOrders";
import WorkOrdersSummary from "./Accounting/getWorkOrdersSummary";
import GetGeneratedInvoice from "./Accounting/getGeneratedInvoice";
import MonthlyForecastTotal from "./Accounting/getMonthlyForecastTotal";
import GetAllAcountingListUuid from "./Accounting/getAllAccountListUuid";

// Commercial Management
import CommercialProposal from "./CommercialManagement/proposal";
import CommercialCustomer from "./CommercialManagement/customer";
import Resource from "./CommercialManagement/resource";
import CommercialKanban from "./CommercialManagement/kanban";
import BillingAddress from "./CommercialManagement/billingAddress";

//Field Teach
import FieldStaff from "./FieldTech/getFieldStaff";
import UpdateStaff from "./FieldTech/updateFiledStaff";
import IntialService from "./FieldTech/getServiceAllocationIntial";
import ResidentailService from "./FieldTech/getServiceAllocationResidentail";
import CommercialService from "./FieldTech/getServiceAllocationCommercial";
import InstallService from "./FieldTech/getServiceAllocationInstall";
import WeeklySetup from "./FieldTech/getWeeklySetup";
import CancelledAllocation from "./FieldTech/cancelledAllocation";
import BlockDayList from "./FieldTech/getBlockDayList";
import AddBlockDay from "./FieldTech/addBlockDay";
import WeeklyAvgData from "./FieldTech/getWeeklyAvgData";
import ServiceStatistics from "./FieldTech/getServiceStatistics";
import SingleService from "./FieldTech/getSingleServiceDetails";
import RerunOptimization from "./FieldTech/rerunOptimization";
import FieldServices from "./FieldTech/getFieldServices";
import SaveFieldService from "./FieldTech/saveFieldServicee";
import GetStaffFieldById from "./FieldTech/getFieldStaffById";
import GetViewByWorkOrder from "./FieldTech/getViewByWorkOrder";
import ServiceReasons from "./FieldTech/getServiceReasons";
import ServiceEODReport from './FieldTech/getServiceEODReport';
import ServiceRouteCSVFormat from "./FieldTech/getServiceRouteCSVFormat";
import ServiceRoutePDFFormat from "./FieldTech/getServiceRoutePDFFormat";
import ServiceList from "./FieldTech/getServiceList";
import CustomerServiceList from "./FieldTech/getCustomerList";
import AddNewService from "./FieldTech/addNewService";
import LockService from "./FieldTech/lockService";
import SchedulingErrorsList from "./FieldTech/getSchedulingErrors"

import CheckMailStatus from "./CaseManagement/CheckMail";
import PDFExportStatement from "./CommercialManagement/exportPDFStatement";
import UpdateFieldServiceAllocation from "./FieldTech/updateFieldService";
import DailyLogReports from './Reports/dailyLogReports';
import CustomerStatementReport from './Reports/CustomerStatementReport'
import ReportPdf from './Reports/reportPdf';
import RevenueReport from './Reports/revenueReport';
import CustomerComplaintsReport from './Reports/customerComplaintsReport';
import InvoiceReconciliationReport from './Reports/invoiceReconciliationReport';
import CancellationReport from './Reports/cancellationReport';
import CancellationSummaryReport from './Reports/cancellationSummaryReport';
import Setting from './Settings';
import CommercialSalesReport from './Reports/commercialSalesReport';
import CustomerPriceIncreaseReport from './Reports/customerPriceIncreaseReport';

// Reports
import RoyaltyReport from './Reports/royaltyReport';
import RoyaltyBreakDown from './Reports/royaltyBreakDown';
import ResidentialLeadReport from './Reports/residentialLeadReport';
import ResidentialSignupReport from './Reports/residentialSignupReport';
import CommercialProposalReport from './Reports/commercialProposalReport';
import CommercialSignupReport from './Reports/residentialSignupReport';
import Channels from './Reports/channels';
import CouponCodeReport from "./Reports/getCouponCodeReport";
import ExportReportsCsv from './Reports/getExportReportsCsv';

// dashboard
import Dashboard from "./Dashboard";

// google api
import GoogleApi from './GoogleApi/index';

/**
 * AUTHOR: Ritesh Solanki
 * Change Date : 09/28/2021 (Tuesday)
 * New Redesign Changes 
 */

// Service Order
import ServiceOrderFilter from "./ResidentialManagement/serviceOrderFilter";
import WorkOrderFilter from "./ResidentialManagement/workOrderFilter";
import FieldTechnicianFilter from "./ResidentialManagement/fieldTechnician";
import WorkOrderList from "./ResidentialManagement/workOrder";
import WorkOrderDetail from "./ResidentialManagement/workOrderDetail";
import deactivatedServiceOrder from "./ResidentialManagement/serviceOrder";
import CommercialWorkOrderList from "./CommercialManagement/workOrder";
import CommercialWorkOrder from "./CommercialManagement/getWorkOrder";
// import PostPaymentLog from "./CommercialManagement/updatePaymentLog";

// Payment
import AddPaymentLog from "./ResidentialManagement/addPaymentLog";
import PostPaymentLog from './ResidentialManagement/updatePaymentLog';

// Common
import InvoicesSummary from "./Invoices/InvoicesSummary";
import EmailVerifycation from "./Common/emailVerification";

// Prepay
import Prepay from "./CommercialManagement/prepay"
import Discounts from "./CommercialManagement/discounts";
import ServiceOrders from "./CommercialManagement/serviceOrders";
import CalculatedPrepayPrice from "./CommercialManagement/calculatedPrepayPrice"; 

// Stax
import AddStaxInfo from "./ResidentialManagement/addStaxPaymentInfo";

export default combineReducers({
  Login,
  Register,
  ForgotPwd,
  resetPWD,
  Settings,
  UserList,
  GroupList,
  FranchiseList,
  AddUser,
  USerEditDetails,
  updateUser,
  DeleteUser,
  addGroup,
  CustomerList,
  Lead,
  ServiceOrder,
  UpdateNotification,
  UpdateCard,
  DeleteCard,
  AddCard,
  BlockList,
  AccountNotes,
  CardList,
  NotificationList,
  AuthorizedUser,
  CallLog,
  PricingHistory,
  Pet,
  ServiceOrderEnquiry,
  Service,
  EmailReminder,
  ZipcodeCheck,
  PricingCalc,
  Invoice,
  FieldTechnician,
  DeletePhoneNumber,
  GroupEditDetails,
  DeleteGroup,
  UpdateGroup,
  VerifyRegister,
  AllMessages,
  getReasons,
  NewTicket,
  RepliesonTicket,
  AllCustomer,
  UpdateMesssage,
  MessageCount,
  FieldOffice,
  FranchiseAdd,
  CloseFranchise,
  EditFieldOffice,
  UpdateFranchise,
  AddonUpdated,
  NewFieldAlert,
  FieldAlertsGet,
  UpdateAlert,
  StandardCleaning,
  UpdatePriceMatrix,
  AddInitial,
  GetInitial,
  GetAccountList,
  GetTabData,
  GetManualy,
  DeleteInvoice,
  ExpiredCard,
  DeleteInitial,
  CommercialProposal,
  CommercialCustomer,
  Resource,
  ResendInvoice,
  VoidInvoice,
  SalesByItem,
  InvoiceOverView,
  AggingSummary,
  StripeLogin,
  QuickbookLogin,
  OptimorouteKey,
  FranchiseOverview,
  InitialCleaning,
  GetSuspend,
  MonthlyForecast,
  CommercialKanban,
  BillingAddress,
  FieldStaff,
  UpdateStaff,
  IntialService,
  ResidentailService,
  InstallService,
  CommercialService,
  WeeklySetup,
  SingleInvoice,
  InvoiceDescription,
  WorkOrderTypeDescription,
  UpdateSingleInvoice,
  CancelledAllocation,
  BlockDayList,
  AddBlockDay,
  WeeklyAvgData,
  DeleteLineItems,
  FinalizeInvoice,
  PrintedInvoice,
  SendInvoiceReminder,
  ServiceStatistics,
  SingleService,
  CheckMailStatus,
  PDFExportStatement,
  PaymentHistory,
  PaymentHistoryNew,
  LastThreePayment,
  RerunOptimization,
  UpdateFieldServiceAllocation,
  FieldServices,
  SaveFieldService,
  ServiceEODReport,
  DailyLogReports,
  CustomerStatementReport,
  ReportPdf,
  RevenueReport,
  CustomerComplaintsReport,
  InvoiceReconciliationReport,
  CancellationReport,
  CancellationSummaryReport,
  Setting,
  RoleList,
  Dashboard,
  CommercialSalesReport,
  CustomerPriceIncreaseReport,
  GetStaffFieldById,
  GetViewByWorkOrder,
  ServiceReasons,
  ServiceRouteCSVFormat,
  ServiceRoutePDFFormat,
  ServiceList,
  CustomerServiceList,
  AddNewService,
  GetQuickbooksSync,
  LockService,
  GoogleApi,
  RefundPayment,
  BatchInvoice,
  StaxKeys,
  UpdateStaxKeys,
  StaxCustomer,
  PulseMKeys,
  UpdatePulseMKeys,
  ServiceNotificationKeys,
  UpdateServiceNotificationKeys,
  ServiceOrderFilter,
  WorkOrderFilter,
  FieldTechnicianFilter,
  WorkOrderList,
  WorkOrderDetail,
  deactivatedServiceOrder,
  RepresentativeList,
  ValidateCouponCode,
  SchedulingErrorsList,
  CommercialWorkOrderList,
  CommercialWorkOrder,
  ResVoidInvoice,
  CommVoidInvoice,
  WorkOrders,
  WorkOrdersSummary,
  GetGeneratedInvoice,
  AddPaymentLog,
  PostPaymentLog,
  InvoicesSummary,
  RemainingCreditBalance,
  RoyaltyReport,
  RoyaltyBreakDown,
  InvoiceProcess,
  InvoiceEmailSend,
  ServiceOrders,
  Discounts,
  CalculatedPrepayPrice,
  Prepay,
  EmailVerifycation,
  AddStaxInfo,
  ResidentialLeadReport,
  ResidentialSignupReport,
  CommercialProposalReport,
  CommercialSignupReport,
  Channels,
  MonthlyForecastTotal,
  CouponCodeReport,
  ExportReportsCsv,
  GetAllAcountingListUuid
});
